<template>
  <figure v-if="image">
    <RokkaImage
      v-bind="image"
      :hash="image.file?.rokka?.hash ?? ''"
      :alt="image.alt"
      :title="image.title"
      :source-width="image.file?.rokka?.sourceWidth"
      :source-height="image.file?.rokka?.sourceHeight"
      :config="imageStyle"
      :img-class="imgClass"
      :loading="loading"
      :preload="preload"
      :file-name="image.file?.label"
    />
  </figure>
</template>

<script lang="ts" setup>
import type { DefineImageStyleConfig } from '#rokka/types'
import type { MediaImageFragment } from '#graphql-operations'
import { RokkaImage } from '#components'

defineOptions({
  name: 'MediaImage',
})

withDefaults(
  defineProps<{
    imageStyle: DefineImageStyleConfig | string
    name?: string
    image?: MediaImageFragment['image']
    imgClass?: string
    preload?: boolean
    loading?: 'lazy' | 'eager'
  }>(),
  {
    name: undefined,
    caption: '',
    image: undefined,
    imgClass: 'w-full',
    hideCaption: false,
    loading: 'lazy',
  },
)
</script>
